module.exports = __webpack_public_path__ + "static/media/gotham-book.d35936d5.woff";